import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface CurrentBranchInfoTooltipProps {
    text: string | null;
    iconClassName?: string;
    containerClassName?: string;
    containerStyle?: React.CSSProperties;
}

const CurrentBranchInfoTooltip: React.FC<CurrentBranchInfoTooltipProps> = ({
    text,
    iconClassName = "bi bi-info-circle",
    containerClassName,
    containerStyle,
}) => {
    if (!text) {
        return null;
    }

    const icon = (
        <OverlayTrigger overlay={<Tooltip>{text}</Tooltip>}>
            <i className={iconClassName}></i>
        </OverlayTrigger>
    );

    if (!containerClassName) {
        return icon;
    }

    return (
        <div className={containerClassName} style={containerStyle}>
            {icon}
        </div>
    );
};

export default React.memo(CurrentBranchInfoTooltip);
